import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;

export const getElevators = () => {
  return axios.get(`${CoreService.getPrivateURL()}elevators/`, {withCredentials:true} );
};
export const getMyElevatorBooking = () => {
  return axios.get(`${CoreService.getPrivateURL()}elevator_booking/`, {withCredentials:true} );
};
export const bookElevator = (data) => {
  return axios.post(`${CoreService.getPrivateURL()}elevator_booking/`, data, {withCredentials:true});
};
export const cancelBookElevator = (booking_id) => {
  return axios.delete(`${CoreService.getPrivateURL()}elevator_booking/${booking_id}`, {withCredentials:true} );
};
export const getElevator = (elevator_id) => {
  return axios.get(`${CoreService.getPrivateURL()}elevators/` + elevator_id, {withCredentials:true} );
};
export const insertElevator = (values) => {
  return axios.post(`${CoreService.getPrivateURL()}elevators/`, values, {withCredentials:true} );
};
export const updateElevator = (elevator_id, data ) => {
  return axios.put(`${CoreService.getPrivateURL()}elevators/${elevator_id}`, data, {withCredentials:true});
};
export const removeElevator = (elevator_id ) => {
  return axios.delete(`${CoreService.getPrivateURL()}elevators/${elevator_id}`, {withCredentials:true});
};
export const disableElevator = (elevator_id ) => {
  return axios.patch(`${CoreService.getPrivateURL()}elevators/${elevator_id}`, {withCredentials:true});
};

const ElevatorsService = {
  getElevators,
  getMyElevatorBooking,
  getElevator,
  insertElevator,
  updateElevator,
  removeElevator,
  disableElevator,
  bookElevator,
  cancelBookElevator,
};
export default ElevatorsService;
